import React from 'react'
import CorprateClientFlow from '../CorprateClientsFlow/CorprateClientFlow'
import MeterFlow from '../MeterFlow/MeterFlow'
import RentalFlow from '../RentalFlow/RentalFlow'
import ThirdpartyFlow from '../ThirdPartyFlow/ThirdPartyFlow'
import { Button } from '@mui/material'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ExtThirdPartyFlow from '../ExternalThirdPartyFlow/ExtThirdPartyFlow'
import PackagesBulkCreate from '../FormsTariff/PackagesBulkCreate'
import CorpBulkCreate from '../FormsTariff/CorpBulkCreate'


function TariffFlow({tabName,setTitle,flowType,handleCloseModal,registerCloseHandler}) {

  const renderFlow = () => {
    if (flowType === 'client') {
      return <CorprateClientFlow setTitle={setTitle} mode="full" />;
    }
    if (flowType === 'package') {
      return <ThirdpartyFlow setTitle={setTitle} mode="packageOnly" />;
    }
    if (flowType === 'rate') {
      return <MeterFlow setTitle={setTitle} mode="rateOnly" />;
    }
    if (flowType === 'packagesBulkCreate') {
      return <PackagesBulkCreate handleCloseModal={handleCloseModal} registerCloseHandler={registerCloseHandler} />;
    }
    if (flowType === 'clientsBulkCreate') {
      return <CorpBulkCreate handleCloseModal={handleCloseModal} registerCloseHandler={registerCloseHandler} />;
    }
  }
  return (
    <div>
      {/* {tabName === "Corporate Client" ? <CorprateClientFlow setTitle={setTitle}/> :""}
      {tabName === "Meter" ? <MeterFlow setTitle={setTitle}/> :""}
      {tabName === "Rental" ? <RentalFlow setTitle={setTitle}/> :""}
      {tabName === "Corporate Packages" ? <ThirdpartyFlow setTitle={setTitle}/> :""},
      {tabName === "External ThirdParty" ? <ExtThirdPartyFlow setTitle={setTitle}/> :""} */}
      {renderFlow()}
    </div>
  )
}

export default TariffFlow;
